

  import Vue from 'vue'
  import Component from "vue-class-component";

  import {Prop, Watch} from "vue-property-decorator";
  import {namespace} from "vuex-class";
  import {IOnOffHandlers} from "bonomo/dist";
  import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
  import {IErrors} from "@/model/IErrors";
  import {ICommunityOption, ITypeExtensionMap} from "@/store/modules/serviceProviderModule";
  import {IShortChannel} from "@/model/shortInterfaces";

  const serviceProviderModule = namespace("serviceProviderModule");
  const channelModule = namespace("channelModule");

  @Component({

  })
  export default class SPSettings extends Vue {

    @Prop()
    protected provider!: IServiceProvider;
    @Prop()
    protected errors!: IErrors;
    @Prop()
    protected editing!: boolean;
    @Prop()
    protected viewing!: boolean;
    @Prop()
    protected disabled!: boolean;
    @Prop()
    protected submitted!: boolean;

    @channelModule.Getter('channels')
    protected channels!: IShortChannel[];
    @channelModule.Action('fetchChannels')
    protected fetchChannels!: () => void;

    protected get selectedChannelId(): number|null {
      return this.provider.channel_ids.length ? this.provider.channel_ids[0] : null;
    }

    protected set selectedChannelId(channelId: number|null) {
      this.provider.channel_ids = channelId ? [channelId] : [];
    }

    protected get channelErrors(): string[] {
      if (this.errors.channel_ids) {
        return this.errors.channel_ids;
      }
      return this.submitted && !this.provider.channel_ids.length
          ? [this.$t('common.validation.required').toString()]
          : [];
    }

    @serviceProviderModule.Getter('typeExtensionMaps')
    protected typeExtensionMaps!: ITypeExtensionMap[];
    @serviceProviderModule.Getter('communities')
    protected communities!: ICommunityOption[];
    @serviceProviderModule.Action('fetchCommunities')
    protected fetchCommunities!: () => void;

    protected get showDetails(): boolean {
      return this.editing || this.viewing;
    }
    protected get statusItems(): any[] {
      const types: any = this.$t('services.provider.fields.status.values');
      return Object.keys(types).map(each => ({
        text: types[each],
        value: each,
      }));
    }
    protected get urgencyTagTypeItems(): any[] {
      const types: any = this.$t('services.provider.fields.urgency_tag_type.values');
      return Object.keys(types).map(each => ({
        text: types[each],
        value: each,
      }));
    }
    protected get typeItems(): any[] {
      const types: any = this.$t('services.provider.fields.type.values');
      return Object.keys(types).map(each => ({
        text: types[each],
        value: each,
      }));
    }
    protected get extensionModels(): any {
      let ret: any = {};
      Object.keys(this.$t('services.provider.fields.extensions.values'))
          .forEach((eachKey: string) => ret[eachKey] = this.hasExtension(eachKey));
      return ret;
    }
    protected get showAutoConfirm(): boolean {
      return this.notInfoCard();
    }
    protected get showItemTracking(): boolean {
      return this.notInfoCard();
    }
    protected get isInfoCard(): boolean {
      return this.provider.type == 'infocard' || this.provider.type == 'infocard_sending';
    }
    protected get showDeliveryAddress(): boolean {
      return this.provider.type == 'amazon_return';
    }
    protected get showReturnUploadEnabled(): boolean {
      return this.provider.type == 'amazon_return';
    }
    protected get isProfessionalServices(): boolean {
      return this.provider.type == 'professional_services';
    }
    protected get isWebview(): boolean {
      return this.provider.type == 'webview';
    }
    protected get linkLocaleItems(): string[] {
      const link = this.provider.link;
      return (link && typeof link === 'object') ? Object.keys(link) : [];
    }
    protected get integrationDataInput(): string {
      const value = this.provider.integration_data;
      if (typeof value === 'string') {
        return value;
      }
      if (!value) {
        return '';
      }
      return JSON.stringify(value, null, 2);
    }
    protected set integrationDataInput(value: string) {
      if (!value || !value.trim()) {
        this.provider.integration_data = null;
        return;
      }

      try {
        const parsed = JSON.parse(value);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          this.provider.integration_data = parsed;
        } else {
          this.provider.integration_data = null;
        }
      } catch (e) {
        this.provider.integration_data = value;
      }
    }

    protected get limitedToModel(): number[] {
      const value = this.provider.limited_to;
      if (Array.isArray(value)) {
        return (value as Array<string | number>)
          .map((item: string | number): number => Number(item))
          .filter((n: number): boolean => Number.isFinite(n));
      }
      return [];
    }

    protected set limitedToModel(value: number[]) {
      this.provider.limited_to = Array.isArray(value) && value.length
        ? value
          .map((item: number): number => Number(item))
          .filter((n: number): boolean => Number.isFinite(n))
        : null;
    }

    protected loading: boolean = false;
    protected linkTab: any = null;
    private subscribes: IOnOffHandlers = {};

    created() {
      this.loadData();
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.OK.typeExtensionMapsLoaded': this.onLoaded,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected hasExtension(extension: string): number {
      return this.provider &&
          this.provider.extensions &&
          this.provider.extensions.indexOf(extension) !== -1
          ? 1 : 0;
    }

    protected extensionsChanged() {
      const allExtensions = this.typeExtensionMaps && this.provider
        ? (this.typeExtensionMaps as any)[this.provider.type]
        : [];
      this.provider.extensions = allExtensions
        .filter((eachExtension: string) => !!this.extensionModels[eachExtension])
        .sort();
    }

    private loadData() {
      this.$store.dispatch('serviceProviderModule/fetchTypeExtensionMaps');
      this.fetchCommunities();
      this.fetchChannels();
    }

    private onLoaded() {
      this.loading = false;
    }

    private notInfoCard(): boolean {
      const excluded_types = [
        'infocard',
        'offline',
      ];
      return excluded_types.indexOf(this.provider.type) === -1;
    }
  }

